import React, { Component } from 'react';
import ReCAPTCHA from "react-google-recaptcha";

class Welcome extends Component {
    constructor(props) {
        super(props);
        this.state = {
            captchaSiteKey: props.config.CaptchaSiteKey != "" ? props.config.CaptchaSiteKey : "6LdRybsiAAAAAG8U3Cq1Mdp0b9khSkfmQsG9Hn48"
        }
    }

    onChange(value) {
        console.log("Captcha value:", value);
        this.props.getResult();
    }

    validateCaptcha() {
        this.props.getResult();
    }

    onSubmit = () => {
        this.props.getResult();
    }

    render() {
        return (
            <div>
                <section>
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 mt-4">
                                <div className="pm_landingview_div">
                                    <div>
                                        <h1 className="agentName">{this.props.agentDetails.AgentFullName}</h1>
                                        {/* <h3>welcomes you to Scope Of Appointment(SOA) for electronic signature</h3> */}
                                        {/* <h5>Welcomes you for an electronic</h5>
                                        <h5>signature on a SOA form</h5> */}
                                        <h5>Welcomes you for an electronic signature on a SOA form !</h5>
                                        {/* <h5>A secure website to electronically sign the Scope Of Appointment (SOA) form</h5> */}
                                    </div>

                                    <div>

                                        <form onSubmit={this.onSubmit.bind(this)}>
                                            <div className="row mt-4">
                                                <div className="col-lg-4 col-md-3 col-sm-2"></div>
                                                <div className="col-lg-4 col-md-6 col-sm-8">
                                                    <ReCAPTCHA
                                                        sitekey={this.state.captchaSiteKey}
                                                        onChange={this.onChange.bind(this)}
                                                    />
                                                </div>
                                                <div className="col-lg-4 col-md-3 col-sm-2"></div>
                                            </div>
                                            {/* <button type="submit" className="pm_landingview_btn">Submit</button> */}
                                        </form>
                                    </div>
                                    <div>
                                        {this.props.config.InstructionsVideo_Enable === true &&
                                            (
                                                <div>
                                                    <span>&nbsp;</span>
                                                    <h5><a href={this.props.config.InstructionsVideo_Link} target="_blank">Click here </a> to watch instructions video</h5>
                                                </div>
                                            )}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <br />
                        <p className="note"><span style={{ color: "#FF0000" }}>Note:</span> The CMS requires agents to document the scope of appointment prior to the sales appointment taking place. If you have questions, please email <strong className="agentName">{this.props.agentDetails.AgentFullName}</strong> at <a href={"mailto:" + this.props.agentDetails.AgentEmail} >{this.props.agentDetails.AgentEmail}</a></p>
                    </div>
                </section>
            </div>
        );
    }
}

export default Welcome;